import { api } from "@/lib/api";

let installed = false;

function reportClientError(type, error, extra = {}) {
  try {
    api.post("/client-errors", {
      type,
      message: error?.message || String(error || ""),
      stack: error?.stack || "",
      componentStack: extra.componentStack || "",
      path: window.location.pathname,
      ...extra,
    }).catch(() => {});
  } catch {
    // keep error reporting from causing a second user-facing error
  }
}

export function installGlobalErrorReporting() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (event) => {
    reportClientError(event.error?.name || "WindowError", event.error || event.message, {
      source: event.filename || "",
      line: event.lineno || 0,
      column: event.colno || 0,
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    reportClientError("UnhandledPromiseRejection", event.reason || "Unhandled promise rejection");
  });
}

export { reportClientError };
